import CoreAPIService from '../../../utils/core-api';
import { fetchAction } from '../../actions';
import { Snappay } from '../api-types';

export const name: string = 'snappay';

export const types = {
    GET_STATS: name + '/GET_STATS',
    GET_TRANSACTIONS: name + '/GET_TRANSACTIONS',
};

interface SnappayState {
    snappay: Snappay;
}

const initialState: SnappayState = {
    snappay: {} as Snappay,
};

const reducer = (state = initialState, action): SnappayState => {
    const payload = action.payload;
    switch (action.type) {
        case types.GET_STATS:
            return {
                ...state,
                snappay: { ...state.snappay, stats: payload },
            };
        case types.GET_TRANSACTIONS:
            return {
                ...state,
                snappay: { ...state.snappay, transactions: payload },
            };
        default:
            return state;
    }
};
export default reducer;

export const actions = {
    getStats: () => fetchAction(CoreAPIService.get(`/core/expresspayment/stats`), types.GET_STATS, {}),
    getTransactions: () =>
        fetchAction(CoreAPIService.get(`/core/expresspayment/transactions`), types.GET_TRANSACTIONS, {}),
};

const localState = (state: any): SnappayState => state[name] || initialState;
export const selectors = {
    snappay: (state) => localState(state).snappay,
};
